import { render, staticRenderFns } from "./CbxPensionType.vue?vue&type=template&id=5ac4fd12&"
import script from "./CbxPensionType.vue?vue&type=script&lang=ts&"
export * from "./CbxPensionType.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports